'use strict';

var _ = require('lodash');

/**
 * Multi Brush hModel
 * @returns {MultiBrushModel}
 * @constructor
 */
var MultiBrushModel = function MultiBrushModel() {
  /**
   *
   * @constructor
   */
  function MultiBrushModel() {
    this.inactiveRanges = [];
  }

  /**
   * Checks if two ranges are overlapping
   * @param r1 - range to compare
   * @param r2 - range to compare
   * @returns {boolean}
   */
  function overlapping(r1, r2) {
    return Math.max(r1[0], r2[0]) <= Math.min(r1[1], r2[1]);
  }

  /**
   * Adds range to collection
   * @param range
   */
  MultiBrushModel.prototype.addRange = function (range) {
    this.inactiveRanges.push(range);
  };

  /**
   * Clear all ranges
   */
  MultiBrushModel.prototype.clearRanges = function () {
    this.inactiveRanges = [];
  };

  /**
   *
   * @param range
   * @param oldRange
   * @param event
   */
  MultiBrushModel.prototype.addRangeWhenBrushing = function (range, oldRange, event) {
    oldRange = oldRange || range;
    var mode = event && event.mode;
    var extendingExisting = range[0] === oldRange[0] || range[1] === oldRange[1] || range[0] === oldRange[1] || range[1] === oldRange[0];

    // save the old range
    if (mode === 'resize' && !extendingExisting) {
      this.addRange(oldRange);
    }
  };

  /**
   *
   * @param range
   * @returns {*}
   */
  MultiBrushModel.prototype.combineOverlappingRanges = function (range) {
    var toRemove = [];
    _.forEach(this.inactiveRanges, function (inactiveRange) {
      if (overlapping(inactiveRange, range)) {
        toRemove.push(inactiveRange);
        range = [Math.min(inactiveRange[0], range[0]), Math.max(inactiveRange[1], range[1])];
      }
    });
    _.forEach(toRemove, function (ir) {
      this.removeRange(ir);
    }.bind(this));
    return range;
  };

  /**
   *
   * @param range
   * @returns {boolean}
   */
  MultiBrushModel.prototype.contains = function (range) {
    return _.find(this.inactiveRanges, function (r) {
      return r[0] === range[0] && r[1] === range[1];
    }) !== undefined;
  };

  /**
   *
   * @param range
   */
  MultiBrushModel.prototype.removeRange = function (range) {
    _.remove(this.inactiveRanges, function (r) {
      return r[0] === range[0] && r[1] === range[1];
    });
  };

  /**
   *
   * @returns {Array}
   */
  MultiBrushModel.prototype.getInactiveRanges = function () {
    return this.inactiveRanges;
  };

  /**
   *
   * @returns {Number}
   */
  MultiBrushModel.prototype.size = function () {
    return this.inactiveRanges.length;
  };
  return MultiBrushModel;
};
MultiBrushModel.$inject = [];
module.exports = MultiBrushModel;